<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="rule-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <h5 class="title"></h5>
                    <div class="rule-view">
                        <div class="text-item">
                            <div class="tag">1</div>
                            <p>把砍价链接分享给好友，好友砍成功后，双方同时获得积分（每帮砍价或被助力成功1个链接，可获得5积分，各10次，每个大区角色上限可得100积分）</p>
                        </div>
                        <div class="text-item">
                            <div class="tag">2</div>
                            <p>在本次阿斗赶集内每消费10梦三币，可获得1积分（以每单实际付款金额为准）</p>
                        </div>
                        <div class="text-item">
                            <div class="tag">3</div>
                            <p>每个大区角色上限可得5000积分</p>
                        </div>
                        <div class="text-item">
                            <div class="tag">4</div>
                            <p>积分仅在本期阿斗有效，活动结束后不做保留</p>
                        </div>
                    </div>
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>
    .dialog-view{
        z-index: 100;
    }

    .rule-modal{
        width: 625px;
        height: 460px;
        background-image: url(~@/assets/images/modal/bg-modal-rule.png);        
    }

    .title{
        width: 516px;
        height: 51px;
        margin: 0 auto 30px;
        background-image: url(~@/assets/images/modal/title-rule.png);  
    }

    .rule-view{
        padding: 0 42px;
        font-size: 21px;
        color: #696560;

        .text-item{
            position: relative;
            padding-left: 40px;

            .tag{
                position: absolute;
                left: 0;
                top: 0;
                width: 34px;
                height: 34px;
                line-height: 34px;
                text-align: center;
                background-color: #efe6d7;
                color: #8e6e25;
                border: 1px solid #c0b498;
                border-radius: 3px;
            }
        }

        p{
            line-height: 1.8;
            margin-bottom: 20px;
        }
    }      
  
</style>

<script>
export default {
    data () {
        return {
            visible : false,
            text : '',
            rid : 1,
        }
    },  
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
    },
    methods : {
        destroyElement () {
            //this.$be_free();
            document.body.style.overflow = ''; // 出现滚动条
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },        
        closeModal(){
            this.destroyElement()
        },       
    },    
}
</script>